import React, { useEffect, useState } from "react";
import axios from "axios";
import "./PatientInfo.css";
import SkeletonLoader from "../../resuableComponents/SkeletonLoader";
import dayjs from "dayjs";
import MedicalCertificateModal from "./MedicalCertificateModal";
import { jsPDF } from "jspdf";
import headerImage from "../../../Images/header-logo.png";
import footerImage from "../../../Images/footer-logo.png";
import {
  FaUser,
  FaPhoneAlt,
  FaHospital,
  FaExclamationTriangle,
  FaCalendarAlt,
  FaVenusMars,
  FaEnvelope,
  FaMapMarkerAlt,
  FaUserMd,
} from "react-icons/fa";

const socialPlatformLabels = {
  google: "Google",
  facebook: "Facebook",
  instagram: "Instagram",
  whatsapp: "WhatsApp",
  twitter: "Twitter",
  youtube: "YouTube",
};

function formatPatientReference(patient) {
  if (!patient) return "Not Provided";
  if (patient.referenceType === "internal_camp") {
    return patient.campaign_name
      ? `Internal Camp — ${patient.campaign_name}`
      : "Internal Camp";
  }
  if (patient.referenceType === "external_camp") {
    return patient.campaign_name
      ? `External Camp — ${patient.campaign_name}`
      : "External Camp";
  }
  if (patient.referenceType === "social_media") {
    const platform = socialPlatformLabels[patient.socialPlatform] || patient.socialPlatform;
    return platform ? `Social Media — ${platform}` : "Social Media";
  }
  return patient.reference || patient.campaign_name || "Not Provided";
}

const PatientInfo = ({ patientId }) => {
  const [patient, setPatient] = useState(null);
  const [error, setError] = useState("");
  const [isCertModalOpen, setIsCertModalOpen] = useState(false);


  // NEW: for automatic certificate data
  const [latestAdmission, setLatestAdmission] = useState(null);
  const [dischargeCard, setDischargeCard] = useState(null);
  const [treatmentsData, setTreatmentsData] = useState([]);
  useEffect(() => {
    const fetchPatient = async () => {
      try {
        const authData = JSON.parse(localStorage.getItem("authData"));

        if (!authData?.accessToken) {
          setError("Authentication required. Please login again.");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}get-patient?patientId=${patientId}`,
          {
            headers: {
              Authorization: `Bearer ${authData.accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        setPatient(response.data.result);
      } catch (err) {
        console.error("Failed to fetch patient:", err);
        setError("Unable to load patient details. Please try again later.");
      }
    };

    if (patientId) {
      fetchPatient();
    }
  }, [patientId]);

  // useEffect(() => {
  //   const fetchAdmissionData = async () => {
  //     try {
  //       const authData = JSON.parse(localStorage.getItem("authData"));
  //       if (!authData?.accessToken) return;

  //       // 1) All admissions for this patient
  //       const res = await axios.get(
  //         `${process.env.REACT_APP_API_URL}get-all-admission?patientId=${patientId}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${authData.accessToken}`,
  //           },
  //         }
  //       );

  //       const all = res.data.result || [];
  //       if (!all.length) {
  //         setLatestAdmission(null);
  //         setDischargeCard(null);
  //         setTreatmentsData([]);
  //         return;
  //       }

  //       // Prefer discharged admissions; else last one
  //       const discharged = all.filter((a) => a.status === "discharged");
  //       const latest =
  //         discharged[discharged.length - 1] || all[all.length - 1];

  //       setLatestAdmission(latest || null);

  //       if (!latest?._id) {
  //         setDischargeCard(null);
  //         setTreatmentsData([]);
  //         return;
  //       }

  //       // 2) Discharge card for that admission
  //       try {
  //         const dcRes = await axios.get(
  //           `${process.env.REACT_APP_API_URL}get-discharge-card/${latest._id}`,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${authData.accessToken}`,
  //             },
  //           }
  //         );
  //         setDischargeCard(dcRes.data.result || dcRes.data || null);
  //       } catch (e) {
  //         if (e.response?.status === 404) {
  //           // No discharge card yet
  //           setDischargeCard(null);
  //         } else {
  //           console.error("Failed to fetch discharge card:", e);
  //           setDischargeCard(null);
  //         }
  //       }

  //       // 3) Treatments done during this admission
  //       try {
  //         const trtRes = await axios.get(
  //           `${process.env.REACT_APP_API_URL}get-all-treatment?admissionId=${latest._id}`,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${authData.accessToken}`,
  //             },
  //           }
  //         );
  //         setTreatmentsData(trtRes.data.result || []);
  //       } catch (e) {
  //         console.error("Failed to fetch treatments:", e);
  //         setTreatmentsData([]);
  //       }
  //     } catch (e) {
  //       console.error("Failed to fetch admission data:", e);
  //       setLatestAdmission(null);
  //       setDischargeCard(null);
  //       setTreatmentsData([]);
  //     }
  //   };

  //   if (patientId) {
  //     fetchAdmissionData();
  //   }
  // }, [patientId]);

  //   const generateMedicalCertificate = () => {
  //     if (!patient) return;

  //     const doc = new jsPDF({
  //       orientation: "portrait",
  //       unit: "mm",
  //       format: "a4",
  //     });

  //     const pageWidth = doc.internal.pageSize.getWidth();
  //     const pageHeight = doc.internal.pageSize.getHeight();
  //     const margin = 20;
  //     const headerHeight = 25;
  //     const footerHeight = 25;
  //     let yPos = headerHeight + 20;

  //     // ===== HEADER & FOOTER (same as before) =====
  //     if (headerImage) {
  //       doc.addImage(headerImage, "PNG", 0, 0, pageWidth, headerHeight);
  //     }
  //     if (footerImage) {
  //       doc.addImage(
  //         footerImage,
  //         "PNG",
  //         0,
  //         pageHeight - footerHeight,
  //         pageWidth,
  //         footerHeight
  //       );
  //     }

  //     // ===== TITLE =====
  //     doc.setFontSize(16);
  //     doc.setFont("helvetica", "bold");
  //     const hospitalTitle = "ASHTANG AYURVED HOSPITAL";
  //     const titleWidth = doc.getTextWidth(hospitalTitle);
  //     doc.text(hospitalTitle, (pageWidth - titleWidth) / 2, yPos);
  //     yPos += 12;

  //     // ===== MAIN BODY (only name + pronoun) =====
  //  // ===== MAIN BODY using fetched data =====
  // doc.setFontSize(11);
  // doc.setFont("helvetica", "normal");

  // const centerX = pageWidth / 2;
  // doc.text("To whomever it may concern,", centerX, yPos, { align: "center" });
  // yPos += 12;

  // const gender = (patient.gender || "").toLowerCase();
  // const pronoun = gender.startsWith("f") ? "She" : "He";

  // const diagnosis =
  //   dischargeCard?.diagnoses?.[0] ||
  //   (treatmentsData || [])
  //     .map((t) => t.complaints)
  //     .filter(Boolean)[0] ||
  //   "";

  // const advisedFor = dischargeCard?.treatmentAdvice || "panchakarma and physiotherapy treatment";

  // const fromDateStr = latestAdmission?.admissionDate
  //   ? dayjs(latestAdmission.admissionDate).format("DD/MM/YYYY")
  //   : "";
  // const toDateStr = latestAdmission?.dischargedDate
  //   ? dayjs(latestAdmission.dischargedDate, "DD-MM-YYYY").format("DD/MM/YYYY")
  //   : dayjs().format("DD/MM/YYYY");
  // const conditionText = diagnosis || "treatment";

  // const wrap = (text) =>
  //   doc.splitTextToSize(text, pageWidth - margin * 2);

  // // 1) This is to certify...
  // const para1 = `This is to certify that patient ${patient.name} is advised for ${advisedFor} under medical observation.`;
  // wrap(para1).forEach((line) => {
  //   doc.text(line, margin, yPos);
  //   yPos += 6;
  // });
  // yPos += 2;

  // // 2) Suffering from
  // const para2 = `${pronoun} is suffering from ${diagnosis || "__________"}.`;
  // wrap(para2).forEach((line) => {
  //   doc.text(line, margin, yPos);
  //   yPos += 6;
  // });
  // yPos += 2;

  // // 3) Under treatment & rest
  // const para3 = `${pronoun} is under treatment and is advised to take rest.`;
  // wrap(para3).forEach((line) => {
  //   doc.text(line, margin, yPos);
  //   yPos += 6;
  // });
  // yPos += 2;

  // // 4) From–to–for
  // const para4 = `${pronoun} was under treatment from ${fromDateStr || "____"} to ${toDateStr || "____"} for ${conditionText || "__________"}.`;
  // wrap(para4).forEach((line) => {
  //   doc.text(line, margin, yPos);
  //   yPos += 6;
  // });
  // yPos += 10;



  //     // ===== FOLLOWING TREATMENT LIST (reuse your previous code) =====
  //    // ===== FOLLOWING TREATMENT LIST (auto from treatmentsData) =====
  //   doc.setFont("helvetica", "bold");
  //   doc.text("Following treatment was done :-", margin, yPos);
  //   yPos += 8;

  //   doc.setFont("helvetica", "normal");

  //   const leftX = margin;
  //   const rightX = pageWidth / 2 + 5;
  //   let leftY = yPos;
  //   let rightY = yPos;

  //   // Flatten unique treatment names from treatmentsData
  //   const allTreatmentNames = Array.from(
  //     new Set(
  //       (treatmentsData || [])
  //         .flatMap((t) => t.treatments || [])    // adjust if your field is different
  //         .map((tr) => tr.name)
  //         .filter(Boolean)
  //     )
  //   );

  //   allTreatmentNames.forEach((name, index) => {
  //     const label = `${index + 1}) ${name}`;
  //     const isLeftColumn = index % 2 === 0;

  //     if (isLeftColumn) {
  //       doc.text(label, leftX, leftY);
  //       leftY += 6;
  //     } else {
  //       doc.text(label, rightX, rightY);
  //       rightY += 6;
  //     }
  //   });
  //     // ===== DATE & SIGNATURE AT BOTTOM =====
  //     const bottomY = pageHeight - footerHeight - 25;
  //     const today = dayjs().format("DD/MM/YYYY");

  //     doc.setFontSize(10);
  //     doc.text(`Date: ${today}`, margin, bottomY);

  //     const signX = pageWidth - margin - 50;
  //     doc.text("Doctor's Signature", signX, bottomY);
  //     doc.line(signX, bottomY + 2, signX + 45, bottomY + 2);

  //   const safeName = (patient.name || "Patient").replace(/\s+/g, "_");
  //   doc.save(`Medical_Certificate_${safeName}.pdf`);
  // };

  if (error) {
    return (
      <div className="patient-info-container">
        <div className="patient-error-state">
          <div className="patient-error-icon">
            <FaExclamationTriangle />
          </div>
          <h3>Error Loading Patient</h3>
          <p>{error}</p>
          <button
            className="patient-retry-btn"
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  if (!patient) {
    return (
      <div className="patient-info-container">
        <SkeletonLoader variant="patient-info" />
      </div>
    );
  }

  return (
    <div className="patient-info-container">
      <div className="patient-header">
        <div className="patient-avatar-large">
          <span className="patient-avatar-text-large">
            {patient.name.charAt(0).toUpperCase()}
          </span>
        </div>
        <div className="patient-title-info">
          <h1 className="patient-main-name">{patient.name}</h1>
          <p className="patient-id-badge">ID: {patient.patientId}</p>
        </div>
      </div>

      <div className="patient-details-grid">
        {/* Personal Information Card */}
        <div className="patient-info-card">
          <div className="patient-card-header">
            <div className="patient-card-icon personal-icon">
              <FaUser />
            </div>
            <h3 className="patient-card-title">Personal Information</h3>
          </div>
          <div className="patient-card-content">
            <div className="patient-info-row">
              <span className="patient-info-label">
                <FaUser style={{ marginRight: '6px' }} />
                Age
              </span>
              <span className="patient-info-value">{patient.age ?? "N/A"} years</span>
            </div>
            <div className="patient-info-row">
              <span className="patient-info-label">
                <FaVenusMars style={{ marginRight: '6px' }} />
                Gender
              </span>
              <span className="patient-info-value">
                {patient.gender || "Not Provided"}
              </span>
            </div>
            <div className="patient-info-row">
              <span className="patient-info-label">
                <FaCalendarAlt style={{ marginRight: '6px' }} />
                Date of Birth
              </span>
              <span className="patient-info-value">
                {patient.dob
                  ? dayjs(patient.dob).format("DD/MM/YYYY")
                  : "Not Provided"}
              </span>
            </div>
            <div className="patient-info-row">
              <span className="patient-info-label">
                <FaHospital style={{ marginRight: '6px' }} />
                Branch
              </span>
              <span className="patient-info-value">
                {patient.branch || "Not Provided"}
              </span>
            </div>
          </div>
        </div>

        {/* Contact Information Card */}
        <div className="patient-info-card">
          <div className="patient-card-header">
            <div className="patient-card-icon contact-icon">
              <FaPhoneAlt />
            </div>
            <h3 className="patient-card-title">Contact Information</h3>
          </div>
          <div className="patient-card-content">
            <div className="patient-info-row">
              <span className="patient-info-label">
                <FaPhoneAlt style={{ marginRight: '6px' }} />
                Phone
              </span>
              <span className="patient-info-value">
                <a href={`tel:${patient.contact}`} className="patient-contact-link">
                  {patient.contact || "Not Provided"}
                </a>
              </span>
            </div>
            <div className="patient-info-row">
              <span className="patient-info-label">
                <FaEnvelope style={{ marginRight: '6px' }} />
                Email
              </span>
              <span className="patient-info-value">
                <a href={`mailto:${patient.email}`} className="patient-contact-link">
                  {patient.email || "Not Provided"}
                </a>
              </span>
            </div>
            <div className="patient-info-row">
              <span className="patient-info-label">
                <FaMapMarkerAlt style={{ marginRight: '6px' }} />
                Address
              </span>
              <span className="patient-info-value patient-address-text">
                {patient.address || "Not Provided"}
              </span>
            </div>
          </div>
        </div>

        {/* Reference Information Card */}
        <div className="patient-info-card patient-full-width">
          <div className="patient-card-header">
            <div className="patient-card-icon reference-icon">
              <FaHospital />
            </div>
            <h3 className="patient-card-title">Reference Information</h3>
          </div>
          <div className="patient-card-content">
            <div className="patient-info-row">
              <span className="patient-info-label">
                <FaUserMd style={{ marginRight: '6px' }} />
                Reference
              </span>
              <span className="patient-info-value">
                {formatPatientReference(patient)}
              </span>
            </div>
          </div>
        </div>
      </div>

      <MedicalCertificateModal
        open={isCertModalOpen}
        onClose={() => setIsCertModalOpen(false)}
        patient={patient}
      />
    </div>
  );
};

export default PatientInfo;

